import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { toggleCart } from '../actions/shoppingCart';
import { Drawer } from '@material-ui/core';
import { Row, Col, Button } from 'reactstrap';
import { removeFromCart } from '../actions/shoppingCart';
import { useHistory } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';

const SideBar = ({
  shoppingCart,
  products,
  auth,
  guest,
  toggleCart,
  removeFromCart,
}: any) => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const history = useHistory();

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
    };
  }, []);

  const closeCart = () => {
    toggleCart();
  };

  const routeToCart = () => {
    history.push('/cart');
    closeCart();
  };

  const removeItem = (product) => {
    if (auth.isAuthenticated) {
      removeFromCart(product, auth.user.id);
    } else if (guest.userid !== '') {
      removeFromCart(product, guest.userid);
    }
  };

  const routeToSpecificPage = (product) => {
    history.push({
      pathname: `/shop/${product.name.replace(/[^A-Z0-9]+/gi, '-')}/${product._id}`,
      state: { product },
    });
    toggleCart();
  };

  return (
    <Drawer anchor="right" open={shoppingCart.cartOpen === true} onClose={closeCart}>
      <div style={{ width: '300px', lineHeight: 1 }} role="presentation">
        <div
          className=" text-light font-weight-bold  "
          style={{ height: '40px', backgroundColor: 'rgb(236,23,79)' }}
        >
          <h5 className="text-left pl-2 d-inline" style={{ fontSize: '30px' }}>
            Shopping Cart
          </h5>
          <span className="float-right close-btn mr-3" onClick={closeCart}>
            &times;
          </span>
        </div>

        {shoppingCart.cart.length === 0 ? (
          <div className="px-3 py-3" style={{ fontSize: 20 }}>
            You have no items in your shopping cart.
          </div>
        ) : (
          <React.Fragment>
            <div
              className="side-drawer position-absolute"
              style={{ overflowY: 'scroll', overflowX: 'hidden', height: height - 150 }}
            >
              {shoppingCart.cart.map((product) => (
                <div key={product.product._id}>
                  <LoadingOverlay
                    active={shoppingCart.removeFromCartLoading.productId === product.product._id}
                    spinner
                  >
                    <Row className="px-2 py-3 border-bottom ">
                      <Col xs="3">
                        <img
                          src={product.product.image}
                          alt={product.product.name}
                          className="img-fluid"
                          style={{ lineHeight: 0 }}
                        />
                      </Col>
                      <Col xs="9">
                        <span
                          className=" item-delete-button text-dark float-right"
                          onClick={() => removeItem(product.product)}
                        >
                          &times;
                        </span>
                        <div
                          className="eachRow "
                          style={{ lineHeight: '30px' }}
                          onClick={() => routeToSpecificPage(product.product)}
                        >
                          <p
                            className="font-weight-bold pr-4 "
                            style={{ wordWrap: 'break-word', fontSize: '16px' }}
                          >
                            {product.product.name}
                          </p>
                        </div>
                        <div className="mt-3 ">
                          <span className="text-muted d-inline"> QTY: {product.quantity}</span>
                          <span className=" text-muted  font-weight-bold float-right">
                            {' '}
                            $
                            {(
                              Math.round(product.product.price * product.quantity * 100) / 100
                            ).toFixed(2)}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </LoadingOverlay>
                </div>
              ))}
            </div>

            <div className="inner-buttons-container border-top w-100 overflow-hidden">
              <Row className="py-3 ">
                <Col>
                  <span style={{ fontSize: 30 }} className="d-inline pl-2 font-weight-bold ">
                    Total:{' '}
                  </span>
                  <span
                    style={{ fontSize: 30 }}
                    className="float-right font-weight-bold text-muted  pr-2"
                  >
                    $
                    {(
                      Math.round(
                        (shoppingCart.cart.length !== 0
                          ? shoppingCart.cart
                              .map((eachItem) => eachItem.quantity * eachItem.product.price)
                              .reduce((total, currentValue) => total + currentValue)
                          : 0) * 100
                      ) / 100
                    ).toFixed(2)}{' '}
                    AUD
                  </span>
                </Col>
              </Row>

              <Row>
                <Col className="p-0">
                  <Button
                    className="border-0 btn-block bg-light text-muted font-weight-bold px-3 py-3 "
                    style={{ borderRadius: 0 }}
                    onClick={routeToCart}
                  >
                    VIEW CART
                  </Button>
                </Col>
                <Col className="p-0">
                  <Button
                    className="font-weight-bold text-light btn-block px-3 py-3"
                    color="success"
                    style={{ borderRadius: 0 }}
                    onClick={() => {
                      history.push('/checkout');
                      toggleCart();
                    }}
                  >
                    CHECKOUT
                  </Button>
                </Col>
              </Row>
            </div>
          </React.Fragment>
        )}
      </div>
    </Drawer>
  );
};

const mapStateToProps = (state: any) => ({
  shoppingCart: state.cart,
  products: state.products,
  auth: state.form,
  guest: state.guest,
});

export default connect(mapStateToProps, { toggleCart, removeFromCart })(SideBar);
